export default __webpack_public_path__ + "static/media/untitled.33deeac6.glb";